import React, { useState, useEffect } from 'react';
import Spinner from '../components/ui/Spinner';

const months = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' }
];

const FilterDropdown = ({ onFilterChange, loading }) => {
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  
  const currentYear = new Date().getFullYear();
  // Generates years from 2024 onwards based on your logic
  const years = Array.from({ length: currentYear - 2023 }, (_, i) => currentYear - i);

  useEffect(() => {
    // Set default values to current month and year
    const currentDate = new Date();
    setSelectedMonth(String(currentDate.getMonth() + 1).padStart(2, '0'));
    setSelectedYear(String(currentDate.getFullYear()));
  }, []);

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleFilter = () => {
    if (selectedMonth && selectedYear) {
      const startDate = `${selectedYear}-${selectedMonth}-01`;
      const endDate = new Date(selectedYear, selectedMonth, 0).toISOString().split('T')[0];
      onFilterChange(startDate, endDate);
    }
  };

  // Shared Styles for Select Inputs
  const selectStyle = "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 transition-colors";

  return (
    <div className="flex flex-col sm:flex-row gap-3 items-center justify-end w-full">
      
      {/* Month Selector */}
      <div className="w-full sm:w-40">
        <select
          className={selectStyle}
          value={selectedMonth}
          onChange={handleMonthChange}
        >
          {months.map((month) => (
            <option key={month.value} value={month.value}>
              {month.label}
            </option>
          ))}
        </select>
      </div>

      {/* Year Selector */}
      <div className="w-full sm:w-32">
        <select
          className={selectStyle}
          value={selectedYear}
          onChange={handleYearChange}
        >
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      {/* Apply Button */}
      <div className="w-full sm:w-auto">
        <button
          onClick={handleFilter}
          disabled={loading}
          className={`w-full sm:w-auto text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 transition-all flex items-center justify-center gap-2 ${
            loading ? 'opacity-70 cursor-not-allowed' : ''
          }`}
        >
          {loading ? (
            <>
              {/* You can use your Spinner component here, or a simple Tailwind SVG spinner */}
               <Spinner animation="border" size="sm" className="w-4 h-4 text-white" />
               <span>Loading...</span>
            </>
          ) : (
            <>
              <i className="fas fa-filter text-xs"></i>
              <span>Apply Filter</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default FilterDropdown;